export default __webpack_public_path__ + "static/media/uniform.f1ae573d.png";